import DoseableLdnQuestions, {
  DosableLDNQuestionFieldAnswers
} from './dosable/questions';
import ldnQuestions, { LDNQuestionFieldAnswers } from './initial/questions';

const LDNQuestions = [...ldnQuestions, ...DoseableLdnQuestions];
export default LDNQuestions;

export type { LDNQuestionFieldAnswers, DosableLDNQuestionFieldAnswers };
